module.exports = __webpack_public_path__ + "static/media/logo_horizontal.1be8bdab.svg";